import React from "react";
import { startCase } from "lodash";
import DownloadErrors from "../DownloadErrors";
import { FileDownloadOutlined } from "@mui/icons-material";
import generateSummaryPdf from "./generateSummaryPdf";

const SidebarSection = ({ title, subtitle, action }) => {
  return (
    <div className="submission_preview__sidebar__section">
      <div className="submission_preview__sidebar__section__title">{title}</div>
      {subtitle && <div className="submission_preview__sidebar__section__subtitle">{subtitle}</div>}
      {action}
    </div>
  );
};

const SummarySideBar = ({
  submissionType,
  submissions = [],
  currentUser = {},
  submissionName,
  ndcDownloadPath,
  onError,
}) => {
  const hasValidationErrors = !!submissions.find((s) => s.hasErrors);

  const handleDownload = (url) => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Download failed");
        }
        return res.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `${submissionType}_ndc_list.xlsx`;
        a.click();
        URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
        if (onError) {
          onError("Failed to download file. Please try again.");
        }
      });
  };

  return (
    <div className="submission_preview__sidebar">
      <div className="submission_preview__divider submission_preview__divider--no-mg">
        <div className="submission_preview__divider__title submission_preview__divider__title--left submission_preview__divider__title--sidebar">
          Resources
        </div>
      </div>
      <SidebarSection
        title={`${startCase(submissionType)} NDC List`}
        subtitle="We select and process claims with eligible NDC-11s. Download the list to learn which NDCs
          we process."
        action={
          <button
            onClick={() => handleDownload(ndcDownloadPath)}
            className="button button--lg button--white"
          >
            <FileDownloadOutlined style={{ fontSize: "18px", verticalAlign: "text-bottom" }} /> NDC
            List
          </button>
        }
      />
      <SidebarSection
        title="Submission Summary"
        subtitle="The summary provides an overview of what you have uploaded and what will be collected for
          submission."
        action={
          <button
            className={
              submissions.length > 0
                ? "button button--lg button--white"
                : "button button--lg button--white"
            }
            disabled={submissions.length === 0}
            onClick={() => generateSummaryPdf(submissions, currentUser, submissionName)}
          >
            <FileDownloadOutlined style={{ fontSize: "18px", verticalAlign: "text-bottom" }} />{" "}
            Summary
          </button>
        }
      />
      {hasValidationErrors ? (
        <SidebarSection
          title="Validation Alerts"
          subtitle="340B ESP selects, then validates rows. Rows with validation alerts are excluded from
            submission. For your convenience, download the spreadsheet of the excluded rows so that
            you can submit them at a later date."
          action={
            <DownloadErrors
              submissionType={submissionType}
              attachments={submissions}
              className="button button--lg button--white"
              label={
                <>
                  <FileDownloadOutlined
                    style={{ fontSize: "18px", verticalAlign: "text-bottom" }}
                  />{" "}
                  Validation Alert Rows
                </>
              }
            />
          }
        />
      ) : (
        <SidebarSection
          title="Validation Alerts"
          action={
            <div className="submission_preview__notice submission_preview__notice--grey">
              There are no validation alerts on any of your rows.
            </div>
          }
        />
      )}
    </div>
  );
};

export default SummarySideBar;
